<product-card class="d-block px-3 py-3 py-sm-1"
              (click)="onProductTypeClick($event)">
  <product-image class="me-3"
                 data-modal-ignore
                 [imagePreviewTrigger]="productType.image.original"
                 *ngIf="showImage && !!productType.image">
    <img [src]="productType.image.small" alt="Product image">
  </product-image>

  <product-header class="d-flex justify-content-between align-items-start">
    <div class="fw-bold w-60">{{ productType.name }}</div>

    <button class="pointer btn-primary-themed add-to-cart-btn"
            (click)="onShowModal()">
      <i class="icon-plus add-to-cart-icon"></i>
    </button>
  </product-header>

  <product-description [class.small-description]="showImage && !!productType.image">
    <div *ngIf="!uiContext.isXs()" class="font-sm text-muted"
         [innerHTML]="productType?.description">
    </div>
    <product-description-slice
      class="font-sm text-muted"
      *ngIf="uiContext.isXs()"
      [lines]="2"
      [text]="productType?.description"
    ></product-description-slice>
  </product-description>
</product-card>
